/* eslint-disable import/order */
import camelCase from 'lodash/camelCase';
import { summarySoftwareEmbedEntrypoint } from '@jira/spa-apps__summary/src/summarySoftwareEmbedEntrypoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareSummaryEmbedRoute } from '@jira/router-routes__software-summary-embed-routes/src/softwareSummaryEmbedRoute.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const summarySoftwareEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summarySoftwareEmbedEntrypoint,
});

export const softwareSummaryEmbedRouteEntry: Route = createEntry(softwareSummaryEmbedRoute, () => ({
	group: 'software',
	ufoName: 'next-gen-summary-embed',
	layout: chromelessLayout,

	resources: [
		...getNavigationResources(),
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	meta: {
		reporting: {
			id: 'software-summary-embed',
			packageName: camelCase('software-summary-embed'),
			teamName: 'jira-werewolves',
		},
	},

	entryPoint: () => summarySoftwareEmbedPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
